module.exports = __webpack_public_path__ + "fonts/OpenSans-Bold.8ff9b573.ttf";